const ar = {
  home: 'الرئيسية',
  najizData: 'ناجز بيانات',
  intro: {
    subTitle: 'منصة للبيانات العدلية بحوكمة مناسبة للمنشآت لتعزيز نظام أكثر شفافية وكفاءة لدعم الأعمال والمشاريع الجديدة واتخاذ القرارات بشكل أفضل.',
  },
  openData: {
    title: 'البيانات المفتوحة',
    description: 'بيانات وإحصائيات عامة وتفصيلية تعكس واقع العمل للخدمات العدلية المقدمة في جميع مناطق المملكة، ويمكن طلب بيانات إضافية بشرط ألا يتضمن الطلب بيانات خاصة أو ذات طابع سري',
    showData: 'عرض البيانات',
    downloadText: 'إمكانية تنزيل البيانات المفتوحة',
  },
  openDataPolicy: {
    title: 'سياسة البيانات المفتوحة',
    introText: 'تنطبق أحكام هذه السياسة على جميع البيانات والمعلومات العامة التي تنتجها وزارة العدل.',
    purposeText: 'الغرض من هذه السياسة هو وضع أهم الضوابط التنظيمية الخاصة بمشاركة البيانات المفتوحة مع المستفيدين من داخل وخارج الوزارة؛ حيث تعتبر البيانات المفتوحة فرعية من المعلوم​ات العامة.',
    methodsText: 'كما يمكن للمستفيد  الحصول على البيانات من خلال تصفح  التقارير التفاعلية  المدرجة في الصفحة الرئيسية والإنتقال إلى صفحة التفاصيل الخاصه بها وتصدير المعلومات إلى ملف Excel  أو  طلب بيانات إضافية عبر النموذج.',
    dataTypes: {
      title: 'تطبق هذه السياسة على البيانات المفتوحة التي يتم مشاركتها مع الجهات من داخل وخارج الوزارة بغرض نشر أعمال وخدمات المرفق العدلي ورفع مستوى المعرفة والثقافة العدلية وتوفير ذلك، وتشمل الآتي:',
      firstTitle: ' التقارير العدلية التفاعلية بأقسامها المختلفة: (تقارير القضاء ، تقارير التنفيذ، تقارير التوثيق ، تقارير الصفقات العقارية) بالإضافة إلى نشرها في المنصة الوطنية للبيانات المفتوحة وإتاحة البيانات العدلية المتعلقة بخدمات المستفيدين وتطوير الأنظمة والتعاون الدولي وتطوير الموارد البشرية.',
      firstPrefix: 'أولًا:',
      secondTitle: 'الكتاب الإحصائي السنوي.',
      secondPrefix: 'ثانيًا:',
      thirdTitle: 'المجلة العدلية.',
      thirdPrefix: 'ثالثًا:',
      fourthTitle: 'الأحكام والسوابق القضائية.',
      fourthPrefix: 'رابعًا:',
    },
    usageInstructions: {
      title: 'تعليمات الاستخدام: ',
      text1: 'يجب الإشارة لوزارة العدل عند استخدام بياناتها في قسم المراجع وذلك للحفاظ على الملكية الفكرية للوزارة.',
      text2: ' عند استخدام بيانات وزارة العدل لابد من الحفاظ عليها بعدم تعديلها.',
      text3: 'يجب عدم استخدام هذه البيانات في أغراض سياسة أو عنصرية تجاه فئة أو عرق أو دين أو لدعم أي نشاط غير مشروع.',
    },
    usersResponsibility: {
      title: 'مسؤولية مستخدمي البيانات:',
      text1: 'يحق لمستخدمي بيانات وزارة العدل عمل أي دراسات من أي نوع كان ويشترط لذلك المحافظة على سلامة وصحة ودقة البيانات.',
      text2: ' يجب أن تكون نتائج الدراسات التي يتم نشرها خالية من الأخطاء التي تتعلق بصحة وسلامة ودقة البيانات.',
      text3: 'تسعد الوزارة بمشاركة نتائج الدراسات معها عن طريق مكتب إدارة البيانات والخصوصية لتطوير منظومتها العدلية.',
    },
    mojResponsibility: {
      title: 'مسؤولية وزارة العدل:',
      text1: 'تخلي وزارة العدل مسؤوليتها عن أي ضرر أو خسارة قد تلحق بمستخدمي بياناتها المنشورة من الجهات والأفراد.',
      text2: 'هذه البيانات المنشورة قد تتغير أو تحذف نتيجة تحديث البيانات الدوري ؛ فالوزارة لا تضمن استمرارية توافر هذه البيانات.',
    },
    publishingRequirements: {
      title: 'متطلبات نشر البيانات المفتوحة:',
      text1: 'موافقة مسؤول البيانات المفتوحة والمعلومات على النشر.',
    },
    principles: {
      title: 'المبادئ الرئيسية للبيانات المفتوحة',
      availability: 'الأصل في البيانات الإتاحة:',
      availabilityDescription: 'يضمن إتاحة بيانات الوزارة العامة للجميع من خلال الإفصاح عنها أو تمكين الوصول إليها أو استخدامها مالم تقتض طبيعتها عدم الإفصاح عنها أو حماية خصوصيتها أو سريتها.',
      freshness: 'حداثة البيانات:',
      freshnessDescription: ' يتم نشر أحدث إصدار من مجموعة البيانات.',
      comprehensiveness: ' الشمولية:',
      comprehensivenessDescription: ' يجب أن تكون مجموعات البيانات المفتوحة شاملة وتتضمن أكبر قدر ممكن من التفاصيل وأن تعكس البيانات المسجلة بما لا يتعارض مع سياسة حماية البيانات الشخصية.',
      discrimination: 'عدم التمييز:',
      discriminationDescription: ' يجب إتاحة مجموعات البيانات للجميع دون تمييز ودون حاجة للتسجيل في المنصة.',
      financial: 'بدون مقابل مالي:',
      financialDescription: 'يجب إتاحة البيانات المفتوحة للجميع مجاناً.',
      openDataLicense: ' ترخيص البيانات المفتوحة في المملكة: ',
      openDataLicenseDescription: 'يجب أن تخضع البيانات المفتوحة لترخيص يحدد الأساس النظامي لاستخدام البيانات المفتوحة وكذلك الشروط والالتزامات.',
      governanceDevelopment: 'تطوير نموذج الحوكمة وإشراك الجميع:',
      governanceDevelopmentDescription: 'تُمكن البيانات المفتوحة عملية الاطلاع والمشاركة للجميع وتعزز شفافية ومساءلة الجهات العامة ودعم عملية صنع القرار وتقديم الخدمات.',
      developmentAndInnovation: 'التنمية الشاملة والابتكار: ',
      developmentAndInnovationDescription: 'يجب تعزيز إعادة استخدام البيانات المفتوحة. كما يجب التكامل بين الجهات المختلفة لإعداد جيل قادم من المبتكرين في مجال البيانات المفتوحة وإشراك الأفراد والمؤسسات بوجه عام.',
    },
  },
  additionalData: {
    title: 'طلب بيانات إضافية',
    description: 'خدمة تتيح للقطاع الخاص الحصول على بيانات إضافية مخصصة لتلبية احتياجاتهم؛ بشرط ألا يتضمن الطلب بيانات خاصة أو ذات طابع سري.',
    serviceSteps: 'خطوات التقديم على الخدمة',
    step1: 'التحقق من سجل المنشأة الوطني.',
    step2: 'تعبئة البيانات المطلوبة.',
    step3: 'اختيار تفاصيل البيانات الإضافية.',
    step4: 'تقديم الطلب.',

    youShouldKnow: 'يجب أن تعرف',
    feesHint: 'قد يتم طلب رسوم مالية للخدمة',
    startService: 'بدء الخدمة',
  },
  faqsTitle: 'كيف يمكن الاستفادة من البيانات المفتوحة؟',
  applicantName: 'اسم مقدم الطلب',
  applicantNamePlaceholder: 'أدخل اسم مقدم الطلب',
  mobile: 'رقم الجوال',
  mobilePlaceholder: '05xxxxxxxx',
  email: 'البريد الإلكتروني',
  emailPlaceholder: 'John.doe@email.com',
  companyName: 'اسم المنشأة',
  companyNamePlaceholder: 'أدخل اسم المنشأة',
  requestDataType: 'نوع البيانات',
  requestDataTypePlaceholder: 'اختر نوع البيانات',
  requestDescription: 'الغرض من استخدام البيانات',
  requestDescriptionPlaceholder: 'إضافة وصف',
  agreement: 'أقر وأتعهد أنا الموضح بياناتي أعلاه بصحة البيانات المدخلة في الطلب وأتحمل مسؤولية ما يترتب على ذلك. ',
  submitRequest: 'تقديم الطلب',
  theName: 'الاسم',
  backToNajizData: 'العودة لناجز بيانات',
  next: 'التالي',
  cancel: 'إلغاء',
  previous: 'السابق',
  applicantInfo: 'بيانات مقدم الطلب',
  requestDetails: 'تفاصيل الطلب',
  requestPreview: 'معاينة الطلب',
  organizationNationalNumber: 'رقم المنشأة الوطني',
  nationalIdNumber: 'رقم الهوية الوطنية',
  verify: 'تحقق',
  backToVerify: 'العودة للتحقق',
  organizationCRType: 'نوع سجل المنشأة',
  organizationName: 'اسم المنشأة',
  unAvailable: 'غير متوفر',
  pleaseVerifyApplicantData: 'الرجاء التحقق من بيانات مقدم الطلب',
  retreat: 'تراجع',
  rejectRequest: 'إلغاء الطلب',
  cancelRequestConfirmation: 'هل انت متأكد من إلغاء الطلب؟',
  cancelRequestConfirmationText: 'بتأكيد الإلغاء لن يتم حفظ البيانات التي ادخلتها',
  organizationVerificationError: 'عذرًا، لا يمكنك تقديم طلب بيانات إضافية',
  organizationVerificationErrorDescription: ' خدمة مخصصة لحسابات ناجز أعمال. نرجو منك تفعيل حسابك عبر خدمة تفعيل حساب أعمال',
  clickHere: 'اضغط هنا',
  contactInfo: 'بيانات التواصل',
  additionalPhoneNumber: 'رقم جوال آخر',
  additionalDataDetails: 'تفاصيل البيانات الإضافية',
  edit: 'تعديل',
  requestStatus: 'حالة الطلب',
  requestSuccessMessage: 'تم تقديم طلبك بنجاح',
  requestSuccessDescription: 'تم استقبال طلبك وسيتم  تدقيقه و إشعارك  من خلال بيانات الاتصال المرفقة في الطلب لاستكمال الإجراءات',
  additionalRequestSentSuccessfully: 'تم تقديم طلب بيانات إضافية بنجاح',

  validators: {
    onlyNumbers: 'الرجاء إدخال أرقام فقط',
    onlyArabicOrEnglishChars: 'الرجاء إدخال أحرف عربية أو إنجليزية فقط.',
  },
  serverErrors: {
    SERVER_ERROR: 'حدث خطأ في النظام الرجاء المحاولة لاحقاً',
  },
};

export default ar;
